import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  maintenanceCategoryList: [],
  maintenanceCategoryById: {},
  maintenanceCategoryByType: [],

  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    maintenanceByType: false,
  },
  error: false,
  errorMessage: "",
};


const maintenanceCategorySlice = createSlice({
  name: "maintenanceCategory",
  initialState,
  reducers: {
    getMaintenanceCategoryList(state, action) {
      state.maintenanceCategoryList = action.payload;
      state.loading.read = false;
      state.error = false;
    },
    MaintenanceCategoryById(state, action) {
      state.maintenanceCategoryById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    MaintenanceCategoryByType(state, action) {
      state.maintenanceCategoryByType = action.payload;
      state.loading.maintenanceByType = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.errorMessage = action.payload;
      state.error = true;
      Object.keys(state.loading).forEach((key) => {
        state.loading[key] = false;
      });
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});


export const {
  getMaintenanceCategoryList,
  MaintenanceCategoryById,
  MaintenanceCategoryByType,
  errorMessages,
  setLoading,
  hideErrorMessage,
} = maintenanceCategorySlice.actions;

export default maintenanceCategorySlice.reducer;
export const maintenanceCategoryReducer = maintenanceCategorySlice.reducer;
